var city = {
  citycode: [],
  adcode: "460000",
  name: "海南省",
  center: {
    lng: 110.348781,
    lat: 20.018639
  },
  districtList: [
    {
      citycode: "1896",
      adcode: "469024",
      name: "临高县",
      center: {
        lng: 109.690508,
        lat: 19.912025
      },
      districtList: [
        {
          citycode: "1896",
          adcode: "469024",
          name: "博厚镇",
          center: {
            lng: 109.807195,
            lat: 19.989365
          }
        },
        {
          citycode: "1896",
          adcode: "469024",
          name: "南宝镇",
          center: {
            lng: 109.638149,
            lat: 19.751609
          }
        },
        {
          citycode: "1896",
          adcode: "469024",
          name: "和舍镇",
          center: {
            lng: 109.714907,
            lat: 19.671698
          }
        },
        {
          citycode: "1896",
          adcode: "469024",
          name: "调楼镇",
          center: {
            lng: 109.609769,
            lat: 19.923138
          }
        },
        {
          citycode: "1896",
          adcode: "469024",
          name: "东英镇",
          center: {
            lng: 109.612973,
            lat: 19.934938
          }
        },
        {
          citycode: "1896",
          adcode: "469024",
          name: "加来镇",
          center: {
            lng: 109.650909,
            lat: 19.759074
          }
        },
        {
          citycode: "1896",
          adcode: "469024",
          name: "临城镇",
          center: {
            lng: 109.632657,
            lat: 19.753184
          }
        },
        {
          citycode: "1896",
          adcode: "469024",
          name: "多文镇",
          center: {
            lng: 109.751742,
            lat: 19.67362
          }
        },
        {
          citycode: "1896",
          adcode: "469024",
          name: "新盈镇",
          center: {
            lng: 109.619413,
            lat: 19.864946
          }
        },
        {
          citycode: "1896",
          adcode: "469024",
          name: "波莲镇",
          center: {
            lng: 109.614806,
            lat: 19.855541
          }
        },
        {
          citycode: "1896",
          adcode: "469024",
          name: "皇桐镇",
          center: {
            lng: 109.856872,
            lat: 19.732264
          }
        }
      ]
    },
    {
      citycode: "0802",
      adcode: "469025",
      name: "白沙黎族自治县",
      center: {
        lng: 109.4429,
        lat: 19.221641
      },
      districtList: [
        {
          citycode: "0802",
          adcode: "469025",
          name: "南开乡",
          center: {
            lng: 109.293018,
            lat: 19.059602
          }
        },
        {
          citycode: "0802",
          adcode: "469025",
          name: "阜龙乡",
          center: {
            lng: 109.436387,
            lat: 19.33165
          }
        },
        {
          citycode: "0802",
          adcode: "469025",
          name: "细水乡",
          center: {
            lng: 109.526636,
            lat: 19.201248
          }
        },
        {
          citycode: "0802",
          adcode: "469025",
          name: "牙叉镇",
          center: {
            lng: 109.399183,
            lat: 19.138439
          }
        },
        {
          citycode: "0802",
          adcode: "469025",
          name: "元门乡",
          center: {
            lng: 109.449713,
            lat: 19.095705
          }
        },
        {
          citycode: "0802",
          adcode: "469025",
          name: "打安镇",
          center: {
            lng: 109.358207,
            lat: 19.378075
          }
        },
        {
          citycode: "0802",
          adcode: "469025",
          name: "金波乡",
          center: {
            lng: 109.171689,
            lat: 19.276555
          }
        },
        {
          citycode: "0802",
          adcode: "469025",
          name: "青松乡",
          center: {
            lng: 109.293018,
            lat: 19.059602
          }
        },
        {
          citycode: "0802",
          adcode: "469025",
          name: "七坊镇",
          center: {
            lng: 109.139587,
            lat: 19.311855
          }
        },
        {
          citycode: "0802",
          adcode: "469025",
          name: "邦溪镇",
          center: {
            lng: 109.043497,
            lat: 19.419968
          }
        },
        {
          citycode: "0802",
          adcode: "469025",
          name: "荣邦乡",
          center: {
            lng: 109.047772,
            lat: 19.432678
          }
        }
      ]
    },
    {
      citycode: "1892",
      adcode: "469022",
      name: "屯昌县",
      center: {
        lng: 110.101667,
        lat: 19.351662
      },
      districtList: [
        {
          citycode: "1892",
          adcode: "469022",
          name: "坡心镇",
          center: {
            lng: 110.214429,
            lat: 19.310397
          }
        },
        {
          citycode: "1892",
          adcode: "469022",
          name: "南吕镇",
          center: {
            lng: 110.042989,
            lat: 19.268166
          }
        },
        {
          citycode: "1892",
          adcode: "469022",
          name: "屯城镇",
          center: {
            lng: 110.180636,
            lat: 19.319861
          }
        },
        {
          citycode: "1892",
          adcode: "469022",
          name: "新兴镇",
          center: {
            lng: 110.136198,
            lat: 19.558967
          }
        },
        {
          citycode: "1892",
          adcode: "469022",
          name: "枫木镇",
          center: {
            lng: 109.973395,
            lat: 19.190743
          }
        },
        {
          citycode: "1892",
          adcode: "469022",
          name: "南坤镇",
          center: {
            lng: 110.034905,
            lat: 19.407514
          }
        },
        {
          citycode: "1892",
          adcode: "469022",
          name: "乌坡镇",
          center: {
            lng: 110.083261,
            lat: 19.206717
          }
        },
        {
          citycode: "1892",
          adcode: "469022",
          name: "西昌镇",
          center: {
            lng: 109.953863,
            lat: 19.41544
          }
        }
      ]
    },
    {
      citycode: "1898",
      adcode: "469006",
      name: "万宁市",
      center: {
        lng: 110.392605,
        lat: 18.793697
      },
      districtList: [
        {
          citycode: "1898",
          adcode: "469006",
          name: "后安镇",
          center: {
            lng: 110.374318,
            lat: 18.908719
          }
        },
        {
          citycode: "1898",
          adcode: "469006",
          name: "和乐镇",
          center: {
            lng: 110.41586,
            lat: 18.962463
          }
        },
        {
          citycode: "1898",
          adcode: "469006",
          name: "东澳镇",
          center: {
            lng: 110.429479,
            lat: 18.640771
          }
        },
        {
          citycode: "1898",
          adcode: "469006",
          name: "龙滚镇",
          center: {
            lng: 110.475633,
            lat: 18.993293
          }
        },
        {
          citycode: "1898",
          adcode: "469006",
          name: "山根镇",
          center: {
            lng: 110.451557,
            lat: 18.990371
          }
        },
        {
          citycode: "1898",
          adcode: "469006",
          name: "南桥镇",
          center: {
            lng: 110.030918,
            lat: 18.747164
          }
        },
        {
          citycode: "1898",
          adcode: "469006",
          name: "北大镇",
          center: {
            lng: 110.418437,
            lat: 18.985185
          }
        },
        {
          citycode: "1898",
          adcode: "469006",
          name: "三更罗镇",
          center: {
            lng: 110.113025,
            lat: 18.948777
          }
        },
        {
          citycode: "1898",
          adcode: "469006",
          name: "大茂镇",
          center: {
            lng: 110.391696,
            lat: 18.876747
          }
        },
        {
          citycode: "1898",
          adcode: "469006",
          name: "万城镇",
          center: {
            lng: 110.412512,
            lat: 18.826291
          }
        },
        {
          citycode: "1898",
          adcode: "469006",
          name: "礼纪镇",
          center: {
            lng: 110.265921,
            lat: 18.748523
          }
        },
        {
          citycode: "1898",
          adcode: "469006",
          name: "长丰镇",
          center: {
            lng: 110.281098,
            lat: 18.85558
          }
        }
      ]
    },
    {
      citycode: "1894",
      adcode: "469002",
      name: "琼海市",
      center: {
        lng: 110.474524,
        lat: 19.259112
      },
      districtList: [
        {
          citycode: "1894",
          adcode: "469002",
          name: "长坡镇",
          center: {
            lng: 110.497644,
            lat: 19.427753
          }
        },
        {
          citycode: "1894",
          adcode: "469002",
          name: "龙江镇",
          center: {
            lng: 110.377839,
            lat: 19.152396
          }
        },
        {
          citycode: "1894",
          adcode: "469002",
          name: "阳江镇",
          center: {
            lng: 110.343829,
            lat: 19.128946
          }
        },
        {
          citycode: "1894",
          adcode: "469002",
          name: "石壁镇",
          center: {
            lng: 110.330819,
            lat: 19.151644
          }
        },
        {
          citycode: "1894",
          adcode: "469002",
          name: "会山镇",
          center: {
            lng: 110.153445,
            lat: 19.012397
          }
        },
        {
          citycode: "1894",
          adcode: "469002",
          name: "中原镇",
          center: {
            lng: 110.431959,
            lat: 19.060809
          }
        },
        {
          citycode: "1894",
          adcode: "469002",
          name: "塔洋镇",
          center: {
            lng: 110.472088,
            lat: 19.325894
          }
        },
        {
          citycode: "1894",
          adcode: "469002",
          name: "万泉镇",
          center: {
            lng: 110.414108,
            lat: 19.355227
          }
        },
        {
          citycode: "1894",
          adcode: "469002",
          name: "潭门镇",
          center: {
            lng: 110.539051,
            lat: 19.210843
          }
        },
        {
          citycode: "1894",
          adcode: "469002",
          name: "嘉积镇",
          center: {
            lng: 110.421334,
            lat: 19.291689
          }
        },
        {
          citycode: "1894",
          adcode: "469002",
          name: "大路镇",
          center: {
            lng: 110.529076,
            lat: 19.373803
          }
        },
        {
          citycode: "1894",
          adcode: "469002",
          name: "博鳌镇",
          center: {
            lng: 110.492863,
            lat: 19.177047
          }
        }
      ]
    },
    {
      citycode: "1899",
      adcode: "469030",
      name: "琼中黎族苗族自治县",
      center: {
        lng: 109.838423,
        lat: 19.03327
      },
      districtList: [
        {
          citycode: "1899",
          adcode: "469030",
          name: "什运乡",
          center: {
            lng: 109.583026,
            lat: 18.923692
          }
        },
        {
          citycode: "1899",
          adcode: "469030",
          name: "黎母山镇",
          center: {
            lng: 109.824353,
            lat: 19.190837
          }
        },
        {
          citycode: "1899",
          adcode: "469030",
          name: "湾岭镇",
          center: {
            lng: 109.865175,
            lat: 19.096504
          }
        },
        {
          citycode: "1899",
          adcode: "469030",
          name: "红毛镇",
          center: {
            lng: 109.608031,
            lat: 19.033716
          }
        },
        {
          citycode: "1899",
          adcode: "469030",
          name: "和平镇",
          center: {
            lng: 110.052562,
            lat: 18.755917
          }
        },
        {
          citycode: "1899",
          adcode: "469030",
          name: "中平镇",
          center: {
            lng: 110.032689,
            lat: 18.966494
          }
        },
        {
          citycode: "1899",
          adcode: "469030",
          name: "上安乡",
          center: {
            lng: 109.712993,
            lat: 18.899738
          }
        },
        {
          citycode: "1899",
          adcode: "469030",
          name: "吊罗山乡",
          center: {
            lng: 109.930063,
            lat: 18.865272
          }
        },
        {
          citycode: "1899",
          adcode: "469030",
          name: "长征镇",
          center: {
            lng: 109.793068,
            lat: 18.896296
          }
        },
        {
          citycode: "1899",
          adcode: "469030",
          name: "营根镇",
          center: {
            lng: 109.930582,
            lat: 19.089045
          }
        }
      ]
    },
    {
      citycode: "0807",
      adcode: "469007",
      name: "东方市",
      center: {
        lng: 108.651829,
        lat: 19.095187
      },
      districtList: [
        {
          citycode: "0807",
          adcode: "469007",
          name: "大田镇",
          center: {
            lng: 108.771554,
            lat: 19.042603
          }
        },
        {
          citycode: "0807",
          adcode: "469007",
          name: "三家镇",
          center: {
            lng: 108.833188,
            lat: 19.259935
          }
        },
        {
          citycode: "0807",
          adcode: "469007",
          name: "四更镇",
          center: {
            lng: 108.596055,
            lat: 19.187648
          }
        },
        {
          citycode: "0807",
          adcode: "469007",
          name: "新龙镇",
          center: {
            lng: 108.678972,
            lat: 19.017898
          }
        },
        {
          citycode: "0807",
          adcode: "469007",
          name: "八所镇",
          center: {
            lng: 108.780679,
            lat: 19.124742
          }
        },
        {
          citycode: "0807",
          adcode: "469007",
          name: "感城镇",
          center: {
            lng: 108.787859,
            lat: 18.842201
          }
        },
        {
          citycode: "0807",
          adcode: "469007",
          name: "天安乡",
          center: {
            lng: 108.804715,
            lat: 18.97548
          }
        },
        {
          citycode: "0807",
          adcode: "469007",
          name: "板桥镇",
          center: {
            lng: 108.910695,
            lat: 18.807162
          }
        },
        {
          citycode: "0807",
          adcode: "469007",
          name: "东河镇",
          center: {
            lng: 109.015044,
            lat: 19.084384
          }
        },
        {
          citycode: "0807",
          adcode: "469007",
          name: "江边乡",
          center: {
            lng: 109.091697,
            lat: 18.906129
          }
        }
      ]
    },
    {
      citycode: "0809",
      adcode: "469028",
      name: "陵水黎族自治县",
      center: {
        lng: 110.037553,
        lat: 18.506045
      },
      districtList: [
        {
          citycode: "0809",
          adcode: "469028",
          name: "椰林镇",
          center: {
            lng: 110.01969,
            lat: 18.482546
          }
        },
        {
          citycode: "0809",
          adcode: "469028",
          name: "文罗镇",
          center: {
            lng: 109.914457,
            lat: 18.573364
          }
        },
        {
          citycode: "0809",
          adcode: "469028",
          name: "新村镇",
          center: {
            lng: 110.026125,
            lat: 18.445965
          }
        },
        {
          citycode: "0809",
          adcode: "469028",
          name: "黎安镇",
          center: {
            lng: 110.027365,
            lat: 18.450385
          }
        },
        {
          citycode: "0809",
          adcode: "469028",
          name: "群英乡",
          center: {
            lng: 109.847456,
            lat: 18.569653
          }
        },
        {
          citycode: "0809",
          adcode: "469028",
          name: "提蒙乡",
          center: {
            lng: 110.013235,
            lat: 18.640359
          }
        },
        {
          citycode: "0809",
          adcode: "469028",
          name: "隆广镇",
          center: {
            lng: 109.857549,
            lat: 18.480188
          }
        },
        {
          citycode: "0809",
          adcode: "469028",
          name: "三才镇",
          center: {
            lng: 109.963149,
            lat: 18.491519
          }
        },
        {
          citycode: "0809",
          adcode: "469028",
          name: "本号镇",
          center: {
            lng: 109.83713,
            lat: 18.632318
          }
        },
        {
          citycode: "0809",
          adcode: "469028",
          name: "英州镇",
          center: {
            lng: 109.875526,
            lat: 18.473898
          }
        },
        {
          citycode: "0809",
          adcode: "469028",
          name: "光坡镇",
          center: {
            lng: 110.036496,
            lat: 18.559416
          }
        }
      ]
    },
    {
      citycode: "2802",
      adcode: "469027",
      name: "乐东黎族自治县",
      center: {
        lng: 109.173384,
        lat: 18.750063
      },
      districtList: [
        {
          citycode: "2802",
          adcode: "469027",
          name: "莺歌海镇",
          center: {
            lng: 108.7546,
            lat: 18.546375
          }
        },
        {
          citycode: "2802",
          adcode: "469027",
          name: "黄流镇",
          center: {
            lng: 108.804819,
            lat: 18.594264
          }
        },
        {
          citycode: "2802",
          adcode: "469027",
          name: "利国镇",
          center: {
            lng: 108.938223,
            lat: 18.495361
          }
        },
        {
          citycode: "2802",
          adcode: "469027",
          name: "万冲镇",
          center: {
            lng: 109.33172,
            lat: 18.913271
          }
        },
        {
          citycode: "2802",
          adcode: "469027",
          name: "佛罗镇",
          center: {
            lng: 108.789451,
            lat: 18.579735
          }
        },
        {
          citycode: "2802",
          adcode: "469027",
          name: "尖峰镇",
          center: {
            lng: 108.843833,
            lat: 18.624901
          }
        },
        {
          citycode: "2802",
          adcode: "469027",
          name: "大安镇",
          center: {
            lng: 109.231993,
            lat: 18.734953
          }
        },
        {
          citycode: "2802",
          adcode: "469027",
          name: "千家镇",
          center: {
            lng: 109.149747,
            lat: 18.465259
          }
        },
        {
          citycode: "2802",
          adcode: "469027",
          name: "九所镇",
          center: {
            lng: 109.080605,
            lat: 18.45065
          }
        },
        {
          citycode: "2802",
          adcode: "469027",
          name: "抱由镇",
          center: {
            lng: 109.027958,
            lat: 18.797154
          }
        },
        {
          citycode: "2802",
          adcode: "469027",
          name: "志仲镇",
          center: {
            lng: 109.38681,
            lat: 18.60959
          }
        }
      ]
    },
    {
      citycode: "2898",
      adcode: "460300",
      name: "三沙市",
      center: {
        lng: 112.338649,
        lat: 16.831004
      },
      districtList: [
        {
          citycode: "2898",
          adcode: "460302",
          name: "南沙区",
          center: {
            lng: 112.896229,
            lat: 9.548531
          }
        },
        {
          citycode: "2898",
          adcode: "460301",
          name: "西沙区",
          center: {
            lng: 112.346961,
            lat: 16.834372
          }
        }
      ]
    },
    {
      citycode: "1893",
      adcode: "469005",
      name: "文昌市",
      center: {
        lng: 110.797473,
        lat: 19.544234
      },
      districtList: [
        {
          citycode: "1893",
          adcode: "469005",
          name: "文教镇",
          center: {
            lng: 110.855856,
            lat: 19.70832
          }
        },
        {
          citycode: "1893",
          adcode: "469005",
          name: "铺前镇",
          center: {
            lng: 110.675271,
            lat: 20.037734
          }
        },
        {
          citycode: "1893",
          adcode: "469005",
          name: "龙楼镇",
          center: {
            lng: 110.938472,
            lat: 19.660636
          }
        },
        {
          citycode: "1893",
          adcode: "469005",
          name: "东郊镇",
          center: {
            lng: 110.910447,
            lat: 19.629115
          }
        },
        {
          citycode: "1893",
          adcode: "469005",
          name: "昌洒镇",
          center: {
            lng: 110.89478,
            lat: 19.826152
          }
        },
        {
          citycode: "1893",
          adcode: "469005",
          name: "锦山镇",
          center: {
            lng: 110.664,
            lat: 20.027062
          }
        },
        {
          citycode: "1893",
          adcode: "469005",
          name: "文城镇",
          center: {
            lng: 110.702595,
            lat: 19.503784
          }
        },
        {
          citycode: "1893",
          adcode: "469005",
          name: "潭牛镇",
          center: {
            lng: 110.773474,
            lat: 19.744417
          }
        },
        {
          citycode: "1893",
          adcode: "469005",
          name: "公坡镇",
          center: {
            lng: 110.826694,
            lat: 19.852259
          }
        },
        {
          citycode: "1893",
          adcode: "469005",
          name: "东路镇",
          center: {
            lng: 110.716883,
            lat: 19.7226
          }
        },
        {
          citycode: "1893",
          adcode: "469005",
          name: "蓬莱镇",
          center: {
            lng: 110.509637,
            lat: 19.558919
          }
        },
        {
          citycode: "1893",
          adcode: "469005",
          name: "抱罗镇",
          center: {
            lng: 110.739711,
            lat: 19.888896
          }
        },
        {
          citycode: "1893",
          adcode: "469005",
          name: "翁田镇",
          center: {
            lng: 110.808995,
            lat: 19.920147
          }
        },
        {
          citycode: "1893",
          adcode: "469005",
          name: "东阁镇",
          center: {
            lng: 110.855599,
            lat: 19.705977
          }
        },
        {
          citycode: "1893",
          adcode: "469005",
          name: "冯坡镇",
          center: {
            lng: 110.79095,
            lat: 20.028869
          }
        },
        {
          citycode: "1893",
          adcode: "469005",
          name: "重兴镇",
          center: {
            lng: 110.569437,
            lat: 19.477879
          }
        },
        {
          citycode: "1893",
          adcode: "469005",
          name: "会文镇",
          center: {
            lng: 110.722572,
            lat: 19.484181
          }
        }
      ]
    },
    {
      citycode: "0899",
      adcode: "460200",
      name: "三亚市",
      center: {
        lng: 109.511709,
        lat: 18.252865
      },
      districtList: [
        {
          citycode: "0899",
          adcode: "460205",
          name: "崖州区",
          center: {
            lng: 109.172298,
            lat: 18.357572
          }
        },
        {
          citycode: "0899",
          adcode: "460202",
          name: "海棠区",
          center: {
            lng: 109.735676,
            lat: 18.384177
          }
        },
        {
          citycode: "0899",
          adcode: "460204",
          name: "天涯区",
          center: {
            lng: 109.452325,
            lat: 18.298975
          }
        },
        {
          citycode: "0899",
          adcode: "460203",
          name: "吉阳区",
          center: {
            lng: 109.578238,
            lat: 18.28146
          }
        }
      ]
    },
    {
      citycode: "0805",
      adcode: "460400",
      name: "儋州市",
      center: {
        lng: 109.580812,
        lat: 19.520948
      },
      districtList: [
        {
          citycode: "0805",
          adcode: "460400",
          name: "光村镇",
          center: {
            lng: 109.46734,
            lat: 19.903531
          }
        },
        {
          citycode: "0805",
          adcode: "460400",
          name: "新州镇",
          center: {
            lng: 109.320933,
            lat: 19.752347
          }
        },
        {
          citycode: "0805",
          adcode: "460400",
          name: "海头镇",
          center: {
            lng: 109.028046,
            lat: 19.432317
          }
        },
        {
          citycode: "0805",
          adcode: "460400",
          name: "中和镇",
          center: {
            lng: 109.351017,
            lat: 19.774675
          }
        },
        {
          citycode: "0805",
          adcode: "460400",
          name: "峨蔓镇",
          center: {
            lng: 109.332639,
            lat: 19.843794
          }
        },
        {
          citycode: "0805",
          adcode: "460400",
          name: "三都镇",
          center: {
            lng: 109.204266,
            lat: 19.83005
          }
        },
        {
          citycode: "0805",
          adcode: "460400",
          name: "木棠镇",
          center: {
            lng: 109.346666,
            lat: 19.900381
          }
        },
        {
          citycode: "0805",
          adcode: "460400",
          name: "排浦镇",
          center: {
            lng: 109.219523,
            lat: 19.631492
          }
        },
        {
          citycode: "0805",
          adcode: "460400",
          name: "王五镇",
          center: {
            lng: 109.277591,
            lat: 19.624562
          }
        },
        {
          citycode: "0805",
          adcode: "460400",
          name: "白马井镇",
          center: {
            lng: 109.232173,
            lat: 19.580719
          }
        },
        {
          citycode: "0805",
          adcode: "460400",
          name: "兰洋镇",
          center: {
            lng: 109.73577,
            lat: 19.40836
          }
        },
        {
          citycode: "0805",
          adcode: "460400",
          name: "那大镇",
          center: {
            lng: 109.559561,
            lat: 19.50011
          }
        },
        {
          citycode: "0805",
          adcode: "460400",
          name: "大成镇",
          center: {
            lng: 109.371806,
            lat: 19.478206
          }
        },
        {
          citycode: "0805",
          adcode: "460400",
          name: "东成镇",
          center: {
            lng: 109.597935,
            lat: 19.726594
          }
        },
        {
          citycode: "0805",
          adcode: "460400",
          name: "雅星镇",
          center: {
            lng: 109.305133,
            lat: 19.393438
          }
        },
        {
          citycode: "0805",
          adcode: "460400",
          name: "和庆镇",
          center: {
            lng: 109.739681,
            lat: 19.587333
          }
        },
        {
          citycode: "0805",
          adcode: "460400",
          name: "南丰镇",
          center: {
            lng: 109.543297,
            lat: 19.504378
          }
        }
      ]
    },
    {
      citycode: "0801",
      adcode: "469029",
      name: "保亭黎族苗族自治县",
      center: {
        lng: 109.700279,
        lat: 18.640339
      },
      districtList: [
        {
          citycode: "0801",
          adcode: "469029",
          name: "南林乡",
          center: {
            lng: 109.576563,
            lat: 18.389262
          }
        },
        {
          citycode: "0801",
          adcode: "469029",
          name: "毛感乡",
          center: {
            lng: 109.503131,
            lat: 18.556288
          }
        },
        {
          citycode: "0801",
          adcode: "469029",
          name: "六弓乡",
          center: {
            lng: 109.74474,
            lat: 18.574041
          }
        },
        {
          citycode: "0801",
          adcode: "469029",
          name: "什玲镇",
          center: {
            lng: 109.736545,
            lat: 18.697785
          }
        },
        {
          citycode: "0801",
          adcode: "469029",
          name: "保城镇",
          center: {
            lng: 109.773883,
            lat: 18.600774
          }
        },
        {
          citycode: "0801",
          adcode: "469029",
          name: "新政镇",
          center: {
            lng: 109.603989,
            lat: 18.435464
          }
        },
        {
          citycode: "0801",
          adcode: "469029",
          name: "响水镇",
          center: {
            lng: 109.550646,
            lat: 18.610753
          }
        },
        {
          citycode: "0801",
          adcode: "469029",
          name: "三道镇",
          center: {
            lng: 109.702909,
            lat: 18.430953
          }
        },
        {
          citycode: "0801",
          adcode: "469029",
          name: "加茂镇",
          center: {
            lng: 109.674549,
            lat: 18.516922
          }
        }
      ]
    },
    {
      citycode: "1897",
      adcode: "469001",
      name: "五指山市",
      center: {
        lng: 109.516784,
        lat: 18.774827
      },
      districtList: [
        {
          citycode: "1897",
          adcode: "469001",
          name: "毛阳镇",
          center: {
            lng: 109.449705,
            lat: 18.881089
          }
        },
        {
          citycode: "1897",
          adcode: "469001",
          name: "毛道乡",
          center: {
            lng: 109.356022,
            lat: 18.713388
          }
        },
        {
          citycode: "1897",
          adcode: "469001",
          name: "水满乡",
          center: {
            lng: 109.600698,
            lat: 18.899478
          }
        },
        {
          citycode: "1897",
          adcode: "469001",
          name: "番阳镇",
          center: {
            lng: 109.333537,
            lat: 18.913174
          }
        },
        {
          citycode: "1897",
          adcode: "469001",
          name: "南圣镇",
          center: {
            lng: 109.684604,
            lat: 18.822608
          }
        },
        {
          citycode: "1897",
          adcode: "469001",
          name: "畅好乡",
          center: {
            lng: 109.383431,
            lat: 18.682307
          }
        },
        {
          citycode: "1897",
          adcode: "469001",
          name: "通什镇",
          center: {
            lng: 109.623006,
            lat: 18.822353
          }
        }
      ]
    },
    {
      citycode: "0803",
      adcode: "469026",
      name: "昌江黎族自治县",
      center: {
        lng: 109.055783,
        lat: 19.298139
      },
      districtList: [
        {
          citycode: "0803",
          adcode: "469026",
          name: "乌烈镇",
          center: {
            lng: 108.809852,
            lat: 19.352543
          }
        },
        {
          citycode: "0803",
          adcode: "469026",
          name: "石碌镇",
          center: {
            lng: 108.997547,
            lat: 19.244929
          }
        },
        {
          citycode: "0803",
          adcode: "469026",
          name: "叉河镇",
          center: {
            lng: 108.997547,
            lat: 19.244929
          }
        },
        {
          citycode: "0803",
          adcode: "469026",
          name: "昌化镇",
          center: {
            lng: 108.73172,
            lat: 19.383636
          }
        },
        {
          citycode: "0803",
          adcode: "469026",
          name: "王下乡",
          center: {
            lng: 109.094025,
            lat: 18.905182
          }
        },
        {
          citycode: "0803",
          adcode: "469026",
          name: "十月田镇",
          center: {
            lng: 108.842173,
            lat: 19.252501
          }
        },
        {
          citycode: "0803",
          adcode: "469026",
          name: "七叉镇",
          center: {
            lng: 109.077512,
            lat: 19.190357
          }
        },
        {
          citycode: "0803",
          adcode: "469026",
          name: "海尾镇",
          center: {
            lng: 108.952319,
            lat: 19.494543
          }
        }
      ]
    },
    {
      citycode: "0806",
      adcode: "469021",
      name: "定安县",
      center: {
        lng: 110.358001,
        lat: 19.681215
      },
      districtList: [
        {
          citycode: "0806",
          adcode: "469021",
          name: "岭口镇",
          center: {
            lng: 110.276026,
            lat: 19.360104
          }
        },
        {
          citycode: "0806",
          adcode: "469021",
          name: "龙门镇",
          center: {
            lng: 110.297826,
            lat: 19.499676
          }
        },
        {
          citycode: "0806",
          adcode: "469021",
          name: "定城镇",
          center: {
            lng: 110.317065,
            lat: 19.701678
          }
        },
        {
          citycode: "0806",
          adcode: "469021",
          name: "新竹镇",
          center: {
            lng: 110.165312,
            lat: 19.577271
          }
        },
        {
          citycode: "0806",
          adcode: "469021",
          name: "雷鸣镇",
          center: {
            lng: 110.30053,
            lat: 19.498361
          }
        },
        {
          citycode: "0806",
          adcode: "469021",
          name: "黄竹镇",
          center: {
            lng: 110.348146,
            lat: 19.445919
          }
        },
        {
          citycode: "0806",
          adcode: "469021",
          name: "龙湖镇",
          center: {
            lng: 110.401131,
            lat: 19.606699
          }
        },
        {
          citycode: "0806",
          adcode: "469021",
          name: "龙河镇",
          center: {
            lng: 110.258715,
            lat: 19.361056
          }
        },
        {
          citycode: "0806",
          adcode: "469021",
          name: "富文镇",
          center: {
            lng: 110.223762,
            lat: 19.422974
          }
        },
        {
          citycode: "0806",
          adcode: "469021",
          name: "翰林镇",
          center: {
            lng: 110.28587,
            lat: 19.349021
          }
        }
      ]
    },
    {
      citycode: "0804",
      adcode: "469023",
      name: "澄迈县",
      center: {
        lng: 110.007497,
        lat: 19.738885
      },
      districtList: [
        {
          citycode: "0804",
          adcode: "469023",
          name: "老城镇",
          center: {
            lng: 110.152799,
            lat: 19.872233
          }
        },
        {
          citycode: "0804",
          adcode: "469023",
          name: "瑞溪镇",
          center: {
            lng: 110.111302,
            lat: 19.789006
          }
        },
        {
          citycode: "0804",
          adcode: "469023",
          name: "大丰镇",
          center: {
            lng: 109.988855,
            lat: 19.904039
          }
        },
        {
          citycode: "0804",
          adcode: "469023",
          name: "加乐镇",
          center: {
            lng: 110.061273,
            lat: 19.617646
          }
        },
        {
          citycode: "0804",
          adcode: "469023",
          name: "仁兴镇",
          center: {
            lng: 109.776963,
            lat: 19.382054
          }
        },
        {
          citycode: "0804",
          adcode: "469023",
          name: "中兴镇",
          center: {
            lng: 109.760023,
            lat: 19.528937
          }
        },
        {
          citycode: "0804",
          adcode: "469023",
          name: "金江镇",
          center: {
            lng: 109.976112,
            lat: 19.774256
          }
        },
        {
          citycode: "0804",
          adcode: "469023",
          name: "福山镇",
          center: {
            lng: 109.919175,
            lat: 19.929023
          }
        },
        {
          citycode: "0804",
          adcode: "469023",
          name: "桥头镇",
          center: {
            lng: 109.936766,
            lat: 19.914013
          }
        },
        {
          citycode: "0804",
          adcode: "469023",
          name: "文儒镇",
          center: {
            lng: 110.134745,
            lat: 19.633652
          }
        },
        {
          citycode: "0804",
          adcode: "469023",
          name: "永发镇",
          center: {
            lng: 110.186668,
            lat: 19.641706
          }
        }
      ]
    },
    {
      citycode: "0898",
      adcode: "460100",
      name: "海口市",
      center: {
        lng: 110.198418,
        lat: 20.045805
      },
      districtList: [
        {
          citycode: "0898",
          adcode: "460108",
          name: "美兰区",
          center: {
            lng: 110.366359,
            lat: 20.028983
          }
        },
        {
          citycode: "0898",
          adcode: "460107",
          name: "琼山区",
          center: {
            lng: 110.384318,
            lat: 19.984293
          }
        },
        {
          citycode: "0898",
          adcode: "460106",
          name: "龙华区",
          center: {
            lng: 110.328628,
            lat: 20.030843
          }
        },
        {
          citycode: "0898",
          adcode: "460105",
          name: "秀英区",
          center: {
            lng: 110.293566,
            lat: 20.007703
          }
        }
      ]
    }
  ]
};

export default city;



// WEBPACK FOOTER //
// ./src/util/province/hainan.js